module.exports = __webpack_public_path__ + "static/media/image4.39cd84e6.png";